<!-- eslint-disable vue/no-mutating-props -->
<template>
  <woot-modal class="contact-form-modal" :show.sync="show" :on-close="onCancel">
    <contact-form
      :contact="contact"
      :in-progress="uiFlags.isUpdating"
      :on-submit="onSubmit"
      @success="onSuccess"
      @cancel="onCancel"
    />
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ContactForm from './ContactForm.vue';

export default {
  components: {
    ContactForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
  },

  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      await this.$store.dispatch('contacts/update', contactItem);
      await this.$store.dispatch(
        'contacts/fetchContactableInbox',
        this.contact.id
      );
    },
  },
};
</script>
